export const environment = {
    production: false,
    geantEnv: 'https://sandbox.geant.hub2b.travel',
    hub2bEnv: '.hub2b.aititubi.es',
    translationUrl: 'https://sandbox.widget.hub2b.travel/'
};